import styles from './FigmaLayout.module.scss';

/**
 * Figma auto-layout primitive — maps layoutMode, itemSpacing, padding, alignment.
 */
export function FigmaAutoLayout({
  direction = 'vertical',
  gap,
  padding,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  align = 'center',
  justify = 'start',
  width,
  height,
  className = '',
  style = {},
  children,
  as: Tag = 'div',
}) {
  const pad =
    padding != null
      ? typeof padding === 'number'
        ? `${padding}px`
        : padding
      : [
          paddingTop ?? 0,
          paddingRight ?? 0,
          paddingBottom ?? 0,
          paddingLeft ?? 0,
        ]
          .map((v) => (typeof v === 'number' ? `${v}px` : v))
          .join(' ');

  const alignMap = {
    start: styles.alignStart,
    center: styles.alignCenter,
    end: styles.alignEnd,
    stretch: styles.alignStretch,
  };
  const justifyMap = {
    start: styles.justifyStart,
    center: styles.justifyCenter,
    end: styles.justifyEnd,
    between: styles.justifyBetween,
  };

  return (
    <Tag
      className={[
        styles.al,
        direction === 'horizontal' ? styles.horizontal : styles.vertical,
        alignMap[align] || styles.alignCenter,
        justifyMap[justify] || styles.justifyStart,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        gap: gap != null ? (typeof gap === 'number' ? `${gap}px` : gap) : undefined,
        padding: pad,
        width,
        height,
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}

export function FigmaFixed({ width, height, className = '', style = {}, children, as: Tag = 'div' }) {
  return (
    <Tag className={className} style={{ width, height, flexShrink: 0, boxSizing: 'border-box', ...style }}>
      {children}
    </Tag>
  );
}
